import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import FullscreenExitOutlinedIcon from "@mui/icons-material/FullscreenExitOutlined";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import ListOutlinedIcon from "@mui/icons-material/ListOutlined";
import "./Footer.scss";
import { Button, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Logo from "../../../components/Logo";
import Languages from "../../../components/Languages";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const Footer = () => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  const { t } = useTranslation('global');
  const navigate = useNavigate();
  const dispatch = useDispatch();


  const handleLogout = () => {
      dispatch(logoutUser());
      navigate("/prelogin");
  }
  return (
    <div className="navbar">
      <div className="wrapper">
        <div >
          {/* <input type="text" placeholder="Search..." /> */}
          {/* <SearchOutlinedIcon /> */}
          <div style={{ paddingLeft: '1rem', margin: 10 }}>
            {/* <Logo width={'100'} height={'80'} /> */}
          </div>

        </div>
        <div className="items">
        
          <div className="item">
            {/* <LanguageOutlinedIcon className="icon" />
            <span>English</span>
            <Languages /> */}
          </div>
          {/* <div className="item">
            <DarkModeOutlinedIcon className="icon" />
          </div>
          <div className="item">
            <FullscreenExitOutlinedIcon className="icon" />
          </div>
          <div className="item">
            <NotificationsNoneOutlinedIcon className="icon" />
            <div className="counter">1</div>
          </div>
          <div className="item">
            <ChatBubbleOutlineOutlinedIcon className="icon" />
            <div className="counter">2</div>
          </div>
          <div className="item">
            <ListOutlinedIcon className="icon" />
          </div> */}
          {/* <div className="item">
               
          </div> */}
          
          <div className="item">
            {/* <ListOutlinedIcon className="icon" /> */}
            <Logo width={'20'} height={'20'} /> 
            <span style={{fontSize:16}}>Copyright © 2024 Modum, Inc.</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
